/**
 * Cart drawer V2
 * The drawer's content is re-rendered by the theme after every cart change, so everything here is
 * delegated from the document.
 * - Upsell arrows scroll the "Complete your setup" row by one card.
 * - "Learn more" on the financing line opens Affirm's modal for the cart total.
 */
// Trash icon: handled here for every render of the drawer. Right after an add, the drawer is re-rendered and
// a click could land on a link whose theme handler isn't attached yet, which followed /cart/change and left
// for the cart page. Capture phase, so this runs first and the link never navigates.
document.addEventListener('click', (event) => {
  const link = event.target.closest('.cart-drawer--v2 .cdv2-remove[is="cart-remove-button"]');
  if (!link) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const line = link.getAttribute('data-index');
  const cartItems = link.closest('cart-items');
  if (cartItems && typeof cartItems.updateQuantity === 'function') {
    cartItems.updateQuantity(line, 0);
    return;
  }

  // Theme cart script not ready yet: remove the line ourselves, then let the drawer refresh itself
  fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: line, quantity: 0 })
  })
    .then(() => document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })))
    .catch((error) => console.error(error));
}, { capture: true });

// Quantity menu: copy the choice into the theme's hidden quantity field and fire its change, exactly like the
// theme's own +/- buttons do, so its validation and cart update run unchanged. The menu's own change event is
// stopped here (capture) so <cart-items> doesn't try to validate the <select> itself.
document.addEventListener('change', (event) => {
  const select = event.target.closest?.('.cdv2-qty__select');
  if (!select) return;

  event.stopPropagation();
  const input = select.closest('.cart-quantity__info')?.querySelector('.cdv2-qty-native .quantity__input');
  if (!input) return;
  input.value = select.value;
  input.dispatchEvent(new Event('change', { bubbles: true }));
}, { capture: true });

document.addEventListener('click', (event) => {
  const arrow = event.target.closest('[data-cdv2-scroll]');
  if (arrow) {
    const track = arrow.closest('.cdv2-upsells')?.querySelector('.cdv2-upsells__track');
    const card = track?.querySelector('.cdv2-upsell');
    if (!track || !card) return;
    const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
    track.scrollBy({ left: step * Number(arrow.dataset.cdv2Scroll), behavior: 'smooth' });
    return;
  }

  const affirmLink = event.target.closest('[data-cdv2-affirm]');
  if (affirmLink) {
    event.preventDefault();
    const amount = Number(affirmLink.dataset.amount) || 0;
    if (window.affirm?.ui?.openModal) {
      window.affirm.ui.ready(() => window.affirm.ui.openModal({ amount, pageType: 'cart' }));
    }
  }
});
